module.exports = __webpack_public_path__ + "img/logo.7e4b60b6.png";